import { Box, Card, CardContent, Typography } from "@mui/material";
import moment from "moment-timezone";
import ConversionLine from "visual-components/analyticsDashboard/overviewCard/conversion-line";
import CardDateRangePickerRow from "visual-components/util/cards/card-date-range-picker-row";
import CardTabs from "visual-components/util/cards/card-tabs";
import NoIntegrationEmptyState from "visual-components/util/graphs/no-integrations-empty-state";

/**
 * Conversion Graphs Component
 * Displays conversion metrics with tabs and date range picker
 * @param {Object} props
 * @param {Array} props.tabs - Tab configuration
 * @param {Object} props.data - Conversion data
 * @param {Function} props.switchTab - Tab switch handler
 * @param {string} props.conversionSelection - Currently selected tab
 * @param {Date} props.oldestDate - Oldest date for picker
 * @param {Function} props.changeFilter - Filter change handler
 * @param {Object} props.datePickerData - Date picker configuration
 * @param {boolean} props.hasAnyActiveIntegrations - Whether integrations exist
 * @param {Date} props.firstConversion - First conversion date
 * @param {Function} props.handleUpsellClick - Upsell click handler
 * @param {boolean} props.smaller - Use smaller height
 * @returns {import("react").ReactElement}
 */
export default function ConversionGraphs(props) {
  const {
    tabs,
    data,
    switchTab,
    conversionSelection,
    oldestDate,
    changeFilter,
    datePickerData,
    hasAnyActiveIntegrations,
    firstConversion,
    handleUpsellClick,
    smaller,
  } = props;

  // depending on tab selection, pick the relevant data to render graph
  const graphData = data[conversionSelection];

  const aggregates = !hasAnyActiveIntegrations
    ? { revenue: -1, transactions: -1 }
    : data.aggregates;

  return (
    <Card sx={{ height: smaller ? 480 : "auto", overflow: "visible" }}>
      <CardContent sx={{ p: 0 }}>
        <CardTabs tabs={tabs} data={aggregates} switchTab={switchTab} selectedTab={conversionSelection} />
        {!hasAnyActiveIntegrations ? (
          <NoIntegrationEmptyState upsellClickHandler={handleUpsellClick} />
        ) : (
          <>
            <Box sx={{ p: 3 }}>
              <ConversionLine data={graphData} />
            </Box>
            <Box sx={{ pl: 3, pb: 1, height: 30 }}>
              {firstConversion && (
                <Typography variant="caption">
                  First Conversion:&nbsp;{moment(firstConversion).format("ll")}
                </Typography>
              )}
            </Box>
          </>
        )}

        {changeFilter && (
          <CardDateRangePickerRow oldestDate={oldestDate} changeFilter={changeFilter} {...datePickerData} />
        )}
      </CardContent>
    </Card>
  );
}
